import moment from "moment";
import "moment/locale/es";
import { dineroDisabledMask } from "../Components/Items";

moment.locale("es");

const tipoLabel = (tipo) => {
  if (tipo === "facturaCompleta") return "Factura Completa";
  if (tipo === "insumoFactura") return "Insumo de Factura";
  if (tipo === "insumoCompleto") return "Insumo Completo";
  return tipo;
};

const prorrateosPdf = (data) => {
  const { prorrateo, empresa, facturaOrigen, facturaObjetivo, ordenDeCompraObjetivo, usuario, poliza, logoBiwo } = data;

  const esObjetivoOrdenDeCompra = prorrateo.tipoObjetivo === "ordenDeCompra";
  const objetivoLabel = esObjetivoOrdenDeCompra ? "Orden de compra objetivo:" : "Factura objetivo:";
  const objetivoTexto = esObjetivoOrdenDeCompra
    ? [ordenDeCompraObjetivo?.serieOrdenCompra, ordenDeCompraObjetivo?.numero].filter(Boolean).join(" ") +
      " — " + (ordenDeCompraObjetivo?.proveedor?.razonSocial || "")
    : (facturaObjetivo?.codigoFactura || "") + " — " + (facturaObjetivo?.proveedor?.razonSocial || "");

  const logoEmpresa = empresa?.logo?.base64Completa
    ? { image: empresa.logo.base64Completa, fit: [80, 40], border: [false, false, false, false] }
    : { text: "", border: [false, false, false, false] };

  const logoBiwoImg = logoBiwo?.base64Completa
    ? { image: logoBiwo.base64Completa, fit: [60, 30], border: [false, false, false, false], alignment: "right" }
    : { text: "", border: [false, false, false, false] };

  const insumosRows = (prorrateo.insumos || []).map((ins) => [
    { text: ins.clave || "", style: "textoTablaChico" },
    { text: ins.descripcion || ins.stringBuscar || "", style: "textoTablaChico" },
    { text: ins.cantidad ?? "", style: "textoTablaChico", alignment: "right" },
    { text: dineroDisabledMask(ins.costoAnterior), style: "textoTablaChico", alignment: "right" },
    { text: dineroDisabledMask(ins.costoAdicional), style: "textoTablaChico", alignment: "right" },
    { text: dineroDisabledMask(ins.costoNuevo), style: "textoTablaChico", alignment: "right" },
  ]);

  const insumosOrigenRows = (prorrateo.insumosOrigen || []).map((ins) => [
    { text: ins.clave || "", style: "textoTablaChico" },
    { text: ins.descripcion || ins.stringBuscar || "", style: "textoTablaChico" },
    { text: ins.cantidad ?? "", style: "textoTablaChico", alignment: "right" },
  ]);

  const content = [
    {
      table: {
        widths: ["50%", "50%"],
        body: [[logoEmpresa, logoBiwoImg]],
      },
      layout: "noBorders",
      marginBottom: 4,
    },
    {
      canvas: [{ type: "line", x1: 0, y1: 0, x2: 535, y2: 0, lineWidth: 1, lineColor: "#7AB3D4" }],
      marginBottom: 8,
    },
    {
      columns: [
        { text: "Prorrateo de Costos", style: "titulo" },
        { text: "Folio #" + (prorrateo.folio || ""), style: "folio", alignment: "right" },
      ],
      marginBottom: 12,
    },
    {
      table: {
        widths: ["30%", "70%"],
        body: [
          [
            { text: "Fecha:", style: "subheader", border: [false, false, false, false] },
            { text: moment(prorrateo.fechaRegistro).format("LL"), style: "textoChico", border: [false, false, false, false] },
          ],
          [
            { text: "Tipo:", style: "subheader", border: [false, false, false, false] },
            { text: tipoLabel(prorrateo.tipo), style: "textoChico", border: [false, false, false, false] },
          ],
          prorrateo.tipo === "facturaCompleta"
            ? [
                { text: "Método:", style: "subheader", border: [false, false, false, false] },
                { text: prorrateo.metodo || "", style: "textoChico", border: [false, false, false, false] },
              ]
            : [
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
          [
            { text: "Monto prorrateo:", style: "subheader", border: [false, false, false, false] },
            { text: dineroDisabledMask(prorrateo.montoProrrateo), style: "textoChico", border: [false, false, false, false] },
          ],
          [
            { text: "Factura origen:", style: "subheader", border: [false, false, false, false] },
            {
              text: (facturaOrigen?.codigoFactura || "") + " — " + (facturaOrigen?.proveedor?.razonSocial || ""),
              style: "textoChico",
              border: [false, false, false, false],
            },
          ],
          [
            { text: objetivoLabel, style: "subheader", border: [false, false, false, false] },
            {
              text: objetivoTexto,
              style: "textoChico",
              border: [false, false, false, false],
            },
          ],
        ],
      },
      marginBottom: 12,
    },
    { text: "Insumos afectados", style: "subheader", marginBottom: 4 },
    {
      table: {
        headerRows: 1,
        widths: ["12%", "*", "10%", "14%", "14%", "14%"],
        body: [
          [
            { text: "Clave", style: "tableHeader", fillColor: "#B8D8EE", color: "#1A3A5F" },
            { text: "Descripción", style: "tableHeader", fillColor: "#B8D8EE", color: "#1A3A5F" },
            { text: "Cant.", style: "tableHeader", fillColor: "#B8D8EE", color: "#1A3A5F", alignment: "right" },
            { text: "Costo Ant.", style: "tableHeader", fillColor: "#B8D8EE", color: "#1A3A5F", alignment: "right" },
            { text: "Costo Adic.", style: "tableHeader", fillColor: "#B8D8EE", color: "#1A3A5F", alignment: "right" },
            { text: "Costo Nuevo", style: "tableHeader", fillColor: "#B8D8EE", color: "#1A3A5F", alignment: "right" },
          ],
          ...insumosRows,
        ],
      },
      marginBottom: 12,
    },
  ];

  if (prorrateo.tipo === "insumoCompleto" && insumosOrigenRows.length > 0) {
    content.push(
      { text: "Insumos de la factura de prorrateo", style: "subheader", marginBottom: 4 },
      {
        table: {
          headerRows: 1,
          widths: ["15%", "*", "12%"],
          body: [
            [
              { text: "Clave", style: "tableHeader", fillColor: "#B8D8EE", color: "#1A3A5F" },
              { text: "Descripción", style: "tableHeader", fillColor: "#B8D8EE", color: "#1A3A5F" },
              { text: "Cant.", style: "tableHeader", fillColor: "#B8D8EE", color: "#1A3A5F", alignment: "right" },
            ],
            ...insumosOrigenRows,
          ],
        },
        marginBottom: 12,
      }
    );
  }

  const nombreUsuario = usuario
    ? [usuario.nombre, usuario.apellidoPaterno, usuario.apellidoMaterno].filter(Boolean).join(" ")
    : "";
  const polizaText = poliza
    ? "#" + (poliza.numeroTipoPoliza || "") + " tipo " + (poliza.numeroTipoTipoPoliza || "") + " — " + (poliza.concepto || "")
    : "";

  content.push({
    table: {
      widths: ["30%", "70%"],
      body: [
        [
          { text: "Usuario:", style: "subheader", border: [false, false, false, false] },
          { text: nombreUsuario, style: "textoChico", border: [false, false, false, false] },
        ],
        [
          { text: "Póliza:", style: "subheader", border: [false, false, false, false] },
          { text: polizaText, style: "textoChico", border: [false, false, false, false] },
        ],
      ],
    },
  });

  return {
    pageSize: "LETTER",
    pageMargins: [40, 40, 40, 40],
    content,
    styles: {
      titulo: { fontSize: 16, bold: true },
      folio: { fontSize: 12, bold: true, color: "#5A9BC4" },
      tableHeader: { fontSize: 9, bold: true },
      subheader: { fontSize: 9, bold: true },
      textoChico: { fontSize: 9 },
      textoTablaChico: { fontSize: 8 },
    },
  };
};

export default prorrateosPdf;
